import imageCompression from 'browser-image-compression';

/** Compress a photo for upload (≤ 0.5 MB, ≤ 1200 px) and return it as a base64 data URL. */
export async function fileToCoverDataUrl(file: File): Promise<string> {
  const compressed = await imageCompression(file, {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1200,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: 0.85,
  });
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Could not read the photo'));
    reader.readAsDataURL(compressed);
  });
}
